<template>
  <v-dialog
    v-if="!loadingData"
    v-model="show"
    max-width="600"
    overlay-color="darktext"
    overlay-opacity="0.6"
    :persistent="loading ? true : false"
    disabled
  >
    <v-card
      v-if="dialogVisibleAddPeople == false"
      data-testid="see-all-thread-member"
      class="pa-5"
    >
      <v-card-title>
        {{ confirmationDialogTitleAddPeople }}
        <v-spacer />
        <v-btn
          v-if="isManager == true"
          color="accent"
          class="white"
          fab
          small
          right
          @click.stop="
            dialogVisibleAddPeople=true"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-subtitle class="pb-8">
        {{ peopleInThread }} {{ $tc('peopleNumberTitle', peopleInThread) }}
      </v-card-subtitle>
      <v-divider />
      <div style="height:300px; overflow-y:auto;">
        <div       
          v-for="(user, index) in users"
          :key="index"
          class="list-item"
        >
          <v-list-item>
            <v-list-item-avatar>
              <v-avatar
                size="56"
                class="white--text"
              >
                <img
                  v-if="user.attributes.avatar_thumb == null"
                  :src="defaultImage"
                >
                <img
                  v-else
                  :src="`${user.attributes.avatar_thumb}`"
                >
              </v-avatar>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>{{ user.attributes.first_name }} {{ user.attributes.last_name }}</v-list-item-title>
              <v-list-item-subtitle
                v-if="isOwner == true"
                class="pt-0"
              >
                {{ user.attributes.email }}
              </v-list-item-subtitle>
            </v-list-item-content>

            <v-menu
              v-if="permissions[user.id] != 'Booster' && isOwner"
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mr-1"
                  icon
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon
                    large
                    data-testid="threedots-icon"
                  >
                    mdi-dots-vertical
                  </v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  data-testid="remove-thread-member"
                  router 
                  @click.prevent="
                    selectedUserForDeletion = user
                    dialogVisibleRemoveThreadMember = true, 
                    confirmationDialogTitle = $t('confirmationDialogTitleRemoveThreadMember'), 
                    confirmationDialogText = $t('confirmationDialogTextRemoveThreadMember'), 
                    confirmationDialogSubmitBtn = $t('removeThreadMember')
                    confirmationDialogCancelBtn = $t('no')"                                            
                >
                  <v-list-item-title>{{ $t('removeThreadMember') }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-list-item>
        </div>

        <div
          v-if="users.length"
          v-observe-visibility="handleScrolledToBottom"
        />
      </div>
    </v-card>
    <v-card
      v-else
      data-testid="add-thread-members"
      class="pa-4"
    >
      <v-card-title class="text-h5 font-weight-bold text-center justify-center mb-4 no-break">
        {{ $t('addThreadMemberTitle') }}
      </v-card-title>
      <v-card-subtitle class="text-body-1 darktext--text text-center d-none d-sm-block no-break">
        {{ $t('addThreadMemberDescription') }}
      </v-card-subtitle>
      <v-form
        ref="form"
        v-model="valid"
        @submit.prevent
      >
        <v-card-subtitle class="text-body-2 text-center greytext--text ">
          {{ $t('addThreadMemberFieldDescription') }}
        </v-card-subtitle>
        <v-autocomplete
          v-model="selectedUsers"
          :menu-props="{
            rounded: 'xxl',
            zIndex: '204',
          }"
          :items="items"
          :loading="isLoading"
          :search-input.sync="search"
          color="white"
          hide-details
          hide-selected
          item-text="searchTerm"
          item-value="id"
          :placeholder="$t('typeToSearch')"
          return-object
          multiple
          chips
          clearable
          solo
          class="rounded-xxl text-body-2 mb-6"
          @blur="closeSearch"
          z-index="10px"         
          autofocus
          data-testid="users-input"
          @change="change"
        >
          <template v-slot:no-data>
            <p class="mx-5 mt-4">
              {{ $t('noDataText') }}
            </p>
          </template>
          <template v-slot:selection="data">
            <v-chip
              v-if="data.item.type == 'users'"
              v-bind="data.attrs"
              close
              data-testid="user-chip"
              @click:close="remove(data.item)"
            >
              <v-avatar
                rounded="lg"
                left
              >
                <v-img
                  v-if="data.item.attributes.avatar_thumb == null"
                  src="../assets/user_images/profile-avatar.png"
                />
                <v-img
                  v-else
                  :src="data.item.attributes.avatar_thumb"
                />
              </v-avatar>
              <span class="text-truncate">{{ data.item.attributes.first_name }} {{ data.item.attributes.last_name }}</span>
            </v-chip>
          </template>
          <template v-slot:item="data">
            <v-list-item-avatar
              v-if="data.item.type == 'users'"
              rounded="lg"
            >
              <img
                v-if="data.item.attributes.avatar_thumb == null"
                src="../assets/user_images/profile-avatar.png"
              >
              <img
                v-else
                :src="data.item.attributes.avatar_thumb"
              >
            </v-list-item-avatar>
            <v-list-item-avatar
              v-else
              rounded="lg"
            >
              <img
                v-if="data.item.attributes.avatar_thumb == null"
                src="../assets/user_images/target-group-avatar.png"
              >
            </v-list-item-avatar>
            <v-list-item-content v-if="data.item.type == 'users'">
              <v-list-item-title>{{ data.item.attributes.first_name + ' ' + data.item.attributes.last_name }} </v-list-item-title>
              <v-list-item-subtitle> {{ data.item.attributes.email }} </v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-autocomplete>
        <v-card-actions class="justify-center">
          <v-btn
            ref="cancel"
            data-testid="cancel-button"
            color="darktext"
            min-width="100"
            dark
            elevation="0"
            class="rounded-xxl text-none px-4 cancel"
            :disabled="loading"
            @click="show=false"
          >
            {{ confirmationDialogCancelBtn }}
          </v-btn>
          <v-btn
            ref="submit"
            data-testid="submit-button"
            type="submit"
            color="accent"
            min-width="100"
            dark
            elevation="0"
            class="rounded-xxl text-none px-4 submit"
            :loading="loading"
            @click="addUsers"
          >
            {{ confirmationDialogSubmitBtn }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
    <ConfirmationDialog 
      v-if="dialogVisibleRemoveThreadMember"
      ref="confirmationDialogRemoveThreadMember"
      :visible="dialogVisibleRemoveThreadMember" 
      :cd-title="confirmationDialogTitle" 
      :cd-text="confirmationDialogText" 
      :cd-submit-btn="confirmationDialogSubmitBtn" 
      :cd-cancel-btn="confirmationDialogCancelBtn" 
      data-testid="confirmation-dialog-remove-thread-member" 
      @close="dialogVisibleRemoveThreadMember=false"
      @proceedSubmit="removeThreadMember(selectedUserForDeletion)"
    />
  </v-dialog>
</template>
<script>
import { getThreadMembers,addUsersToThread,removeThreadMember,searchActivityUsersThreadExcluded,getThread } from '../api/forumApi';
import ConfirmationDialog from '../components/ConfirmationDialog'
import i18n from '../plugins/i18n';

export default {
    components: {
        ConfirmationDialog,
    },
    props: {
      visible: Boolean,
        item: {
        type: Object,
        default: () => {}
      }
    },
    data(){
        return{
          valid: true,
          confirmationDialogTitleAddPeople: i18n.t('confirmationDialogTitlePeopleInThread'), 
          dialogVisibleAddPeople: false,
          users:[],
          usersInfo:[],
          permissions:[],
          defaultImage: require('../assets/user_images/profile-avatar.png'),
          alertMsg:'',
          alertType:'',
          alertValue:false,
          confirmationDialogSubmitBtn: i18n.t('add'),
          confirmationDialogCancelBtn: i18n.t('cancel'),
          selectedUserForDeletion:'',
          dialogVisibleRemoveThreadMember:false,
          peopleInThread:0,
          loadingData: false,
          selectedUsers: [],
          entries:[],
          search: null,
          isLoading: false,
          activityId: this.$route.params.id,
          autocompleteRules: [
              v => {
                  if (!v || v.length < 1){
                      return  i18n.t('labelInputRequired');
                  }
                  else return true;
              }
          ],
          errors: [],
          isOwner:this.item.attributes.is_owner,
          isManager:this.item.attributes.is_manager,
          loading:false,
          pageNumber: 1,
          size: 5,
          lastPage: 1,
        }
      },  
      computed: {
          show: {
              get () {
                  return this.visible
              },
              set (value) {
                  if (!value) {
                      this.$emit('close')
                  }
              }
          },
          items () {
              return this.entries.map(entry => {
                  if (entry.type == 'users') {
                      const searchTerm = entry.attributes.first_name + ' ' + entry.attributes.last_name + ' ' + entry.attributes.email
                      return Object.assign({}, entry, { searchTerm })
                  }
              })
          },
          selectedUsersEmails() {
              return this.selectedUsers.map(entry => {
                  if (entry.type == 'users') {
                      if(entry.attributes.email){
                          return entry.attributes.email
                      }
                  }
              })
          },
      },
      watch: {
        async search (val) {
            if (this.isLoading) return 

            var entriesUsers = []
            if(val && val.trim().length >= 2){
                this.isLoading = true
                try {
                    const response = await searchActivityUsersThreadExcluded(this.activityId,this.item.id, val)
                    if(response.status == 200) {
                        // this.entries = response.data.data
                        entriesUsers = response.data.data
                        entriesUsers.forEach(function(item) {
                            item.sort_term = item.attributes.first_name.toLowerCase() + ' ' + item.attributes.last_name.toLowerCase() + ' ' + item.attributes.email.toLowerCase()
                        })
                    }            
                } catch (e) {
                    if(e.response){
                        this.alertValue = true
                        if(e.response.status == 403){
                            this.$router.push({name: 'PageAccessDenied'})
                        } else {
                            this.alertType = 'error'
                            this.alertMsg =  i18n.t('serverError')
                        }
                    }            
                }
                this.entries = entriesUsers
                this.isLoading = false
            }
            this.isLoading = false
        }
    },
    async created(){
      this.loadingData = true
      await this.fetchThreadUsers()
      this.loadingData = false
    },
    methods: {
        change(){
            this.search = ''
        },
        remove(item) {
            this.selectedUsers.splice(this.selectedUsers.indexOf(item), 1)
            this.selectedUsers = [...this.selectedUsers]
        },
        closeSearch(){
          this.search = ''
          this.entries = this.selectedUsers.slice();
        },
        handleScrolledToBottom (isVisible) {
          if (!isVisible) {
            return
          }
          if (this.pageNumber >= this.lastPage) {
            return
          }
          this.pageNumber++
          this.fetchThreadUsers()
        },
        async fetchThreadUsers(){
            try {
                const response = await getThreadMembers(this.item.id,this.size,this.pageNumber)
                if(response.status){
                    if(response.status == 200) {
                        this.users.push(...response.data.data)
                        this.usersInfo = response.data.meta
                        this.permissions = response.data.meta.permissions
                        this.peopleInThread = response.data.meta.total
                        this.lastPage = response.data.meta.lastPage
                    }
                }            
            } catch (e) {
                if(e.response){
                    this.alertValue = true
                    if(e.response.status == 403){
                        this.$router.push({name: 'PageAccessDenied'})
                    } else {
                        this.alertType = 'error'
                        this.alertMsg =  i18n.t('serverError')
                    }
                }            
            }
        },
        async addUsers(){
          this.$emit('proceedSubmit','', '')
          this.$refs.form.validate()
            if(this.valid && (this.selectedUsers.length) ){
                this.loading = true
                try {
                    let data = {
                        data: {
                            type: "thread-users",
                            attributes: {
                                user_email: this.selectedUsersEmails,
                            }
                        }
                    };
                    const response = await addUsersToThread(this.item.id,data)
                    if(response.status == 200) {
                        const response_thread = await getThread(this.item.id)
                        if(response_thread.status == 200){
                          this.show=false
                          this.alertMsg =  i18n.t('addUsersTothreadSuccessfully')
                          this.alertType = 'success'
                          let numberPeople = response_thread.data.data.relationships.users.meta.count
                          this.$emit('proceedSubmit', this.alertMsg, this.alertType,this.item.id,numberPeople)
                        }
                        
                        
                    }            
                } catch (e) {
                    if(e.response){
                        this.alertValue = true
                        if(e.response.status == 403){
                            this.$router.push({name: 'PageAccessDenied'})
                        } else if(e.response.status == 404) {
                            this.$router.push({name: 'PageNotFound'})
                        } else {
                            this.alertType = 'error'  
                            this.alertMsg =  i18n.t('serverError')
                            this.$emit('proceedSubmit', this.alertMsg, this.alertType)
                        }
                    }            
                }
                this.loading=false
          }
        }, 
        async removeThreadMember(user){
            this.dialogVisibleRemoveThreadMember = false;
            try {
                let data = {
                    data: {
                        type: "thread-users",
                        attributes: {
                            'user_email': user.attributes.email
                        }
                    }
                };
                const response = await removeThreadMember(this.item.id, data)
                if(response.status){
                    if(response.status == 200) {
                      const response_thread = await getThread(this.item.id)
                       if(response_thread.status == 200){
                          this.show=false
                          this.alertValue = true
                          this.alertType = 'success'
                          this.alertMsg =  i18n.t('removeThreadMemberSuccess')
                          let numberPeople = response_thread.data.data.relationships.users.meta.count
                          this.$emit('proceedSubmit', this.alertMsg, this.alertType,this.item.id,numberPeople)
                        }
                       
                    }
                }            
            } catch (e) {
                this.dialogVisibleRemoveThreadMember = false;
                if(e.response){
                    this.alertValue = true
                    if (e.response.status == 403){
                      this.$router.push({name: 'PageAccessDenied'})
                    } else if (e.response.status == 400){
                        this.alertType = 'error'
                        this.alertMsg =  i18n.t('canNotRemoveThreadMember')
                    } else {
                        this.alertType = 'error'
                        this.alertMsg =  i18n.t('serverError')
                    }
                }            
            }
        },  
    },
     async showThreadDetail(){ 
      
          try {
                    const response = await getThread(this.item.id)
                    if(response.status == 200) {
                      this.thread = response.data.data
                    }  
                } catch (e) {
                    if(e.response){
                        this.alertValue = true
                        this.alertType = 'error'
                        this.alertMsg =  i18n.t('serverError')
                    } 
                }
    },  
}
</script>
